import { render, staticRenderFns } from "./BaseRangeSwitch.vue?vue&type=template&id=1a2e328c&"
import script from "./BaseRangeSwitch.vue?vue&type=script&lang=js&"
export * from "./BaseRangeSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports